'use strict'

import locales from './locales'

const defLocale = 'en-US'

if (!locales || Object.keys(locales).length === 0) {
  throw new TypeError('Expected locales to have at least one locale.')
}

const MINUTE = 60
const HOUR   = MINUTE * 60
const DAY    = HOUR * 24
const WEEK   = DAY * 7
const MONTH  = DAY * 30
const YEAR   = DAY * 365

const localeCode = {
  NOW   : 0,
  SECOND: 1,
  MINUTE: 2,
  HOUR  : 3,
  DAY   : 4,
  WEEK  : 5,
  MONTH : 6,
  YEAR  : 7,
}

function localize (data, textCode, future = false, localeDataList) {
  const count = Math.round(data)

  let localeData = localeDataList[textCode]
  if (future) {
    localeData = localeDataList[textCode + Object.keys(localeCode).length] || localeData
  }

  if (!localeData) throw new TypeError(`Missing locale text code: ${textCode}`)

  if (typeof localeData === 'object') {
    let lastDigit = count % 10
    if (lastDigit === 0 || (count > 10 && count < 20)) lastDigit = 10

    if (!localeData[1]) throw new TypeError('Expected locales to have at least singular translation')

    while (!localeData[lastDigit]) lastDigit--

    localeData = localeData[lastDigit]
  }

  return localeData.replace(/%s/, (!future && count === 1 ? '' : count)).trim()
}

function formatTime (then, now, locale = 'en-US', formatMax) {
  then = new Date(then)
  now = new Date(now)

  let opts = formatMax
  if (!opts || typeof opts !== 'object') {
    opts = {month: 'long', day: 'numeric'}
  }

  if (!opts.year && then.getYear() !== now.getYear()) {
    opts.year = 'numeric'
  }

  return then.toLocaleString(locale, opts)
}
// function formatTimeMy (then, now, locale = 'en-US') {
//   then = new Date(then)
//   now = new Date(now)
//
//   let day = then.getDate()
//   let month = then.toLocaleString(locale, { month : 'long' })
//
//   let text = `${month} ${day}`
//
//   if (then.getYear() !== now.getYear()) {
//     let year = then.getFullYear()
//     text = `${text}, ${year}`
//   }
//
//   return text
// }

let nowTime
function getNowTime () {
  if (!nowTime) {
    nowTime = new Date().getTime()

    setTimeout(() => {
      nowTime = null
    }, 1000)
  }

  return nowTime
}

// String.prototype.replaceAt = function (index, char) {return this.substr(0, index) + char + this.substr(index+char.length);}
function stringReplaceAt (str, index, char) {
  if (typeof str !== 'string') return ''
  return str.substr(0, index) + char + str.substr(index + char.length)
}

export default {
  render (h) {
    if (this.time && this.objectDate) {
      return h(
        'time',
        {
          attrs: {
            datetime: this.objectDate
          }
        },
        this.timeago
      )
    }
  },
  props   : {
    time      : {
      required: false
    },
    locale    : String,
    showAffix : {
      type : Boolean,
      default : true,
    },
    stepPrecision : {
      type : Number,
      default : 0.8,
      validator : val => (val > 0 && val <= 1)
    },
    maxTime   : [Number, String],
    formatMax : {
      type : [Object],
      default : null,
    },
    autoUpdate: {
      type : Boolean,
      default : true,
    },
    format    : Function
  },
  data () {
    return {
      now: getNowTime()
    }
  },
  computed: {
    objectDate () {
      let date

      if (this.time instanceof Date) {
        if (!this.time.getTime()) return null
        date = new Date(this.time.getTime())
      } else {
        date = new Date(this.time)

        if (!date.getTime() && this.time) { // if (date.toString() === 'Invalid Date')
          if (typeof this.time !== 'string') return null
          // date = new Date(this.time.replaceAt(10, 'T'))
          date = new Date(stringReplaceAt(this.time, 10, 'T'))
        }
      }

      return date
    },
    currentLocale () {
      return this.locale || defLocale
    },
    currentLocaleData () {
      let current = locales[this.currentLocale]
      if (!current) current = locales[defLocale]
      if (!Array.isArray(current) && typeof current === 'object') {
        current = this.showAffix ? current.affix : current.noAffix
      }
      return current
    },
    sinceTime () {
      return this.objectDate.getTime()
    },
    maxSeconds () {
      if (!this.maxTime) return false

      if (typeof this.maxTime === 'number') return this.maxTime

      if (typeof this.maxTime === 'string') {
        switch (this.maxTime.toUpperCase()) {
          case 'MINUTE':
            return MINUTE
          case 'HOUR':
            return HOUR
          case 'DAY':
            return DAY
          case 'WEEK':
            return WEEK
          case 'MONTH':
            return MONTH
          case 'YEAR':
            return YEAR
        }
      }

      return false
    },
    timeago () {
      let seconds = this.now / 1000 - this.sinceTime / 1000

      let future = false
      if (seconds < 0) {
        future = true
        seconds = Math.abs(seconds)
      }

      if (this.maxSeconds && seconds > this.maxSeconds) {
        clearTimeout(this.timeout)
        return this.format
          ? this.format(this.sinceTime, this.now, this.currentLocale, this.formatMax)
          : formatTime(this.sinceTime, this.now, this.currentLocale, this.formatMax)
      }

      const k = this.stepPrecision || 1

      const ret = (seconds <= 5
        ? this.timeagoGenerate(seconds, localeCode.NOW, future)
        : seconds < MINUTE * k
          ? this.timeagoGenerate(seconds, localeCode.SECOND, future)
          : seconds < HOUR * k
            ? this.timeagoGenerate(seconds / MINUTE, localeCode.MINUTE, future)
            : seconds < DAY * k
              ? this.timeagoGenerate(seconds / HOUR, localeCode.HOUR, future)
              : seconds < WEEK * k
                ? this.timeagoGenerate(seconds / DAY, localeCode.DAY, future)
                : seconds < MONTH * k
                  ? this.timeagoGenerate(seconds / WEEK, localeCode.WEEK, future)
                  : seconds < YEAR * k
                    ? this.timeagoGenerate(seconds / MONTH, localeCode.MONTH, future)
                    : this.timeagoGenerate(seconds / YEAR, localeCode.YEAR, future)
      )

      return ret
    }
  },
  watch   : {
    autoUpdate (newVal) {
      this.stopUpdate()
      // only update when it's not falsy value
      // which means you cans set it to 0 to disable auto-update
      if (newVal) {
        this.queueUpdate()
      }
    }
  },
  methods : {
    timeagoGenerate (data, textCode, future = false) {
      let text = this.localize(data, textCode, future)

      let period  = 1000

      switch (textCode) {
        case localeCode.MINUTE:
          period = MINUTE / 4
          break
        case localeCode.HOUR:
          period = HOUR / 4
          break
        case localeCode.DAY:
          period = HOUR
          break
        case localeCode.WEEK:
        case localeCode.MONTH:
        case localeCode.YEAR:
          period = Infinity
          break
      }

      this.queueUpdate(period)

      return text
    },
    localize (data, textCode, future = false) {
      return localize(data, textCode, future, this.currentLocaleData)
    },
    update () {
      this.now = getNowTime()
    },
    queueUpdate (period = 1000) {
      if (period > DAY) return

      period = parseInt(period)
      if (period < 1000) period = 1000

      setTimeout(() => {
        this.update()
      }, period)
    },
    stopUpdate () {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  },
  mounted () {
    if (this.autoUpdate) {
      this.queueUpdate()
    }
  },
  beforeDestroy () {
    this.stopUpdate()
  },
}
